import React from 'react'

import Progress from 'common/components/feedback/Progress'

import { formatMoney } from 'common/moneyFormatter'

import './HraDeductibleSummary.less'

interface HraDeductibleSummaryProps {
  amount: number
  accomplishedAmount: number
  accomplishedPercentage: number
  translate: (key: string) => string
}

const HraDeductibleSummary: React.FC<HraDeductibleSummaryProps> = ({
  amount,
  accomplishedAmount,
  accomplishedPercentage,
  translate,
}) => {
  const getDeductibleDescriptionContent = () => {
    if (accomplishedPercentage === 100) {
      return translate('summary.hra-deductible-acomplished-description')
    } else {
      return translate('summary.hra-deductible-default-description')
    }
  }

  return (
    <div className="hra_deductible_summary">
      <h6 className="summary_title">{translate('summary.hra-deductible-title')}</h6>
      <div className="percentage_completed">
        <h3 className="percentage_value">{accomplishedPercentage.toFixed(2)}%</h3>
        <h6 className="deductible_value_interval pl-8">
          ({formatMoney(accomplishedAmount)} {translate('summary.of-label')} {formatMoney(amount)})
        </h6>
      </div>
      <div className="pt-16 deductible_progress">
        <Progress
          type="circle"
          strokeColor="#11D175"
          strokeLinecap="square"
          percent={+accomplishedPercentage.toFixed(2)}
          trailColor="#FADB14"
        />
        <h6 className="deductible_description pl-24">{getDeductibleDescriptionContent()}</h6>
      </div>
    </div>
  )
}

export default HraDeductibleSummary
